<div #content></div>
<ng-container #mfecomponent></ng-container>
<ndc-dynamic *ngIf="type === 'component'" [ndcDynamicComponent]=component [ndcDynamicInputs]=input ></ndc-dynamic>